/* eslint-disable */
export default {
  mute: 'Silenciar',
  unmute: 'Reactivar',
  hangup: 'Colgar',
  reject: 'Rechazar',
  hold: 'Retener',
  onHold: 'En espera',
  transfer: 'Transferir',
  more: 'Más',
  stopRecord: 'Detener grabación',
  record: 'Grabar',
  showKeypad: 'Teclado',
  hideKeypad: 'Ocultar teclado de marcación',
  unHold: 'Reanudar llamada',
  forward: 'Desviar',
  ignore: 'Ignorar',
  voicemail: 'Al buzón de voz',
  custom: 'Personalizado',
  answerAndEnd: 'Responder y finalizar',
  answerAndHold: 'Responder y poner en espera',
  answer: 'Responder',
  completeTransfer: 'Completar transferencia',
  reply: 'Responder',
  add: 'Añadir',
  mergeCall: 'Combinar con la llamada activa',
  endCallForEveryone: 'Finalizar llamada para todos',
  leaveCall: 'Abandonar llamada',
  leaveOrEndCall: '¿Abandonar o finalizar la llamada?',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop Recording"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"showKeypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hideKeypad"@#@ @source: @#@"Hide Keypad"@#@
// @key: @#@"unHold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"voicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete transfer"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"mergeCall"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"endCallForEveryone"@#@ @source: @#@"End call for everyone"@#@
// @key: @#@"leaveCall"@#@ @source: @#@"Leave call"@#@
// @key: @#@"leaveOrEndCall"@#@ @source: @#@"Leave or end call?"@#@
